module.exports = __webpack_public_path__ + "img/045f3c9.jpg";